export default function removeQuotesFromEncodedURL(encodedStr) {
    if (typeof encodedStr === "string" && encodedStr.length >= 6 && encodedStr.startsWith('%22') && encodedStr.endsWith('%22')) {
      return `${encodedStr.slice(3, -3)}`;
    }
    return encodedStr;
  }